/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var PersonTieOutlineIcon = function PersonTieOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8C17 10.7614 14.7614 13 12 13C9.23858 13 7 10.7614 7 8ZM12 5C10.3431 5 9 6.34315 9 8C9 9.65685 10.3431 11 12 11C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14698 13.0967C4.75391 14.2514 2.89643 16.2384 2.05486 18.6734L1.72821 19.6185L3.6185 20.2718L3.94515 19.3267C4.66952 17.2308 6.40163 15.4922 8.66524 14.615L7.14698 13.0967Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2621 14.5872C17.5613 15.4551 19.3228 17.2084 20.0549 19.3267L20.3815 20.2718L22.2718 19.6185L21.9452 18.6734C21.0956 16.2153 19.2109 14.2139 16.785 13.0642L15.2621 14.5872Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16.5L10 14H14L13 16.5L14 20H10L11 16.5Z"
  }));
};
export default PersonTieOutlineIcon;